import { useEffect, useState } from "react";
import { useScroll, useSpring, motion } from "framer-motion";
import { CorrectContainer } from "./usefulContainers";

export function StylizedCounter({ targetValue, startAtY = 500 }: any) {
  const { scrollY } = useScroll();
  const [hasTriggered, setHasTriggered] = useState(false);
  const [displayValue, setDisplayValue] = useState(0);

  const springValue = useSpring(0, {
    stiffness: 45,
    damping: 20,
  });

  // 1. Handle initial load & scroll triggers
  useEffect(() => {
    const checkPosition = (latest: number) => {
      if (latest > startAtY && !hasTriggered) {
        setHasTriggered(true);
      }
    };

    // Check immediately on mount
    checkPosition(scrollY.get());

    // Listen for scroll
    return scrollY.on("change", checkPosition);
  }, [scrollY, startAtY, hasTriggered]);

  // 2. WATCH THE PROP: Re-animate whenever targetValue changes
  useEffect(() => {
    if (hasTriggered) {
      springValue.set(targetValue);
    }
  }, [targetValue, hasTriggered, springValue]);

  // 3. Keep display value in sync with the spring
  useEffect(() => {
    return springValue.on("change", (latest) => {
      setDisplayValue(Math.round(latest));
    });
  }, [springValue]);

  return (
    <motion.div
      animate={{ 
        opacity: hasTriggered ? 1 : 0, 
        y: hasTriggered ? 0 : 20 
      }}
      transition={{ duration: 0.8 }}
    >
      <CorrectContainer style={{ fontVariantNumeric: "tabular-nums" }}>
        {displayValue}
      </CorrectContainer>
    </motion.div>
  );
}